// extracted by mini-css-extract-plugin
module.exports = {"rightSidePopupLayout":"VariablesRightSidePopupLayout_rightSidePopupLayout__2_QQY"};